import {
  SET_NOTIFICATIONS,
  SET_ENCOURAGE_MSG_READ,
} from "../actions/actionsTypes";

export const notificationsReducer = (state = [], action) => {
  if (action.type === SET_NOTIFICATIONS) {
    return {
      notifications: action.payload,
    };
  }
  if (action.type === SET_ENCOURAGE_MSG_READ) {
    const finalNotifications = state.notifications;
    return {
      notifications: finalNotifications.filter(
        (notification) => notification !== action.payload
      ),
    };
  }
  return state;
};
